import { Component, OnInit } from '@angular/core';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MatomoTracker } from 'ngx-matomo';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-mvmtest',
    templateUrl: './mvmtest.component.html',
    styleUrls: ['./mvmtest.component.css']
})
export class MVMTestComponent extends BaseComponent implements OnInit {
    loading: boolean;
    iframeUrl: string = '';
    historyPriceIsVisible: boolean = false
    title = 'MVM Test Error,Please contact the administrator!';
    safeIframeUrl: SafeResourceUrl;
    constructor(
        private Environment: EnvironmentconfigService,
        private route: ActivatedRoute,
        private router: Router,
        private sanitizer: DomSanitizer
    ) { super() }

    ngOnInit() {
        // 获取完整的URL   U2FsdGVkX1%2BMZJW%2BD5AAWv%2FOyg3Yh0ab5Ddkz1rtI5O2SnPBdklUWpmxLn1u6k9A7r3lU6DZHn1z5QGYAfyKXg%3D%3D


        // 获取路由参数
        this.route.queryParams.subscribe(params => {
            console.log('Query Params:', params);
            console.log('Query Params:', params['param']);


            const fullUrl = this.router.url;
            console.log('Full URL:', fullUrl);
            const url = `${this.Environment.authConfig.mmpUrl}/${params['param']}`
            if (fullUrl.includes('mvmchtest')) {
                this.title = 'MVM測試歷史價格'
                this.iframeUrl = `${url}?Language=zh-TW`
            }
            else if (fullUrl.includes('mvmentest')) {
                this.title = 'MVM Testing Historical Prices'
                this.iframeUrl = `${url}?Language=en-US`
            }
            //local 測試使用
            //this.iframeUrl = `http://localhost:4200/pages/wmsm-pages/Source/buyerapproval`;
            this.safeIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeUrl);
        });

    }

    HistoryPriceCancel() {
        this.historyPriceIsVisible = false
    }

}